(function () {
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  var isMobile = window.screen.width < 768;
  window.addEventListener(
    "resize",
    debounce(() => {
      isMobile = window.screen.width < 768;
    }, 500)
  );

  document.addEventListener("DOMContentLoaded", function () {
    let formData = {};
    const table = document.querySelector("#wl-variants-list");

    if (!table) {
      return;
    }

    const inputs = table.querySelectorAll(".wl-sku-column input");

    if (!inputs || !inputs.length) {
      return;
    }

    inputs.forEach((input) => {
      input.addEventListener("blur", function (e) {
        let sku = e.target.value;
        // if (!sku) return;

        if (!sku) {
          const row = e.target.closest('div[class^="row-"]');
          if (!row) {
            return;
          }
          clear(row);
        } else {
          const row = e.target.closest('div[class^="row-"]');
          const errorEl = row.querySelector(".sku__error-message");
          const inputEl = row.querySelector(".sku__input");

          // Clear previous errors
          errorEl.innerHTML = "";
          inputEl.style.background = "#d9d9d9";

          // First step: Fetch the base SKU result
          // 品番はユーザー入力。& や # 等でクエリが壊れるのを防ぐため値部分をエスケープ
          // （encodeURIComponent はハイフンを変換しないため正常品番では出力不変）。
          fetch(
            `/search?type=product&q=variants.sku:${encodeURIComponent(sku)}`
          )
            .then((response) => response.text())
            .then((text) => {
              const parser = new DOMParser();
              const html = parser.parseFromString(text, "text/html");
              const data = JSON.parse(
                html.querySelector("#search-results-data")?.textContent || "[]"
              );
              console.log("data", data);
              // const inventory = JSON.parse(html.querySelector('#inventory-data')?.textContent || '{}');
              const rawInventory = JSON.stringify(
                html.querySelector("#inventory-data")?.textContent || "{}"
              );
              const inventory = getInventory(rawInventory, sku);

              if (!data.length) {
                clear(row, true);
                showError(inputEl, errorEl, "品番が正しくないです");
                return;
              }

              const groupCodes = getGroupCodes();

              // フォールバック用の通常商品。data[0] を盲目的に採らず、SKU が
              // ちょうど <品番> の商品（=通常商品）を明示的に拾う（並び順が揺れても
              // 取り違えない保険）。見つからなければ現行同等で data[0]。
              const normalProduct =
                data.find((product) =>
                  product.variants.some((variant) => variant.sku === sku)
                ) || data[0];

              if (groupCodes.length > 0) {
                // 各対象コードを完全一致検索（並列）。allSettled で 1 本の通信失敗が
                // 全体を巻き込むのを防ぎ、成功した結果だけで先頭ヒットを採用する。
                Promise.allSettled(
                  groupCodes.map((groupCode) =>
                    fetchSpecialVariant(sku, groupCode)
                  )
                ).then((settled) => {
                  // rejected は null 化。配列順は groupCodes 順を保つため、
                  // find(Boolean) で「成功かつ値あり」の先頭コードを採用する。
                  const hit = settled
                    .map((s) => (s.status === "fulfilled" ? s.value : null))
                    .find(Boolean);

                  if (hit) {
                    processVariant(hit.product, row, hit.fullSku, hit.inventory);
                  } else {
                    // 全コード全滅（ヒットなし or 全失敗）→ 通常商品にフォールバック
                    processVariant(normalProduct, row, sku, inventory);
                  }
                });
              } else {
                // 対象コードなし → 通常商品をそのまま採用
                processVariant(normalProduct, row, sku, inventory);
              }
            })
            .catch((error) => {
              console.error("Error fetching SKU:", error);
              showError(inputEl, errorEl, "エラーが発生しました");
              clear(row);
            });
        }
      });
    });

    // Function to get the inventory data
    function getInventory(rawInventory, sku) {
      const inventoryStr = `"${sku}": `;
      const startIndex = rawInventory.indexOf(sku);
      const newStr = rawInventory.slice(startIndex + inventoryStr.length);
      let inventory = "";
      for (let i = 0; i < newStr.length; i++) {
        if (newStr[i] === "," || newStr[i] === `"`) {
          break;
        }
        inventory += newStr[i];
      }
      if (inventory.length === 0) return 0;
      return parseInt(inventory);
    }

    // 完全一致で特価商品を取得。ヒットしなければ null。
    // 10件枠の #search-results-data ではなく product-search-json（最大250件）で
    // 取得し、検索結果の件数・並び順に依存せず特価 variant を直引きする。
    function fetchSpecialVariant(sku, groupCode) {
      const fullSku = `${sku}-${groupCode}`;
      return fetch(
        `/search?type=product&q=variants.sku:${encodeURIComponent(
          fullSku
        )}&section_id=product-search-json`
      )
        .then((response) => {
          // 429/5xx 等はエラーHTMLが返り JSON.parse が例外を投げる。reject させると
          // allSettled→通常価格フォールバックに静かに流れ「特価が出ず定価」という
          // 本不具合の症状を再発させるため、ログを残して null（=特価なし扱い）を返す。
          if (!response.ok) {
            console.warn(
              `fetchSpecialVariant: HTTP ${response.status} for SKU ${fullSku}`
            );
            return null;
          }
          return response.text();
        })
        .then((text) => {
          if (!text) return null;
          // product-search-json は JSON 配列（最大250件）をそのまま出力する
          let data;
          try {
            const parser = new DOMParser();
            const html = parser.parseFromString(text, "text/html");
            data = JSON.parse(html.body.textContent.trim() || "[]");
          } catch (e) {
            console.warn(
              `fetchSpecialVariant: parse failed for SKU ${fullSku}`,
              e
            );
            return null;
          }
          const product = data.find((p) =>
            p.variants.some((variant) => variant.sku === fullSku)
          );
          if (!product) return null;
          const variant = product.variants.find((v) => v.sku === fullSku);
          // product-search-json は #inventory-data を出力しないため、
          // 在庫表示（表示のみ・非ガード）は variant 情報から導出する
          const inventory =
            variant.inventory_quantity ?? (variant.available ? 1 : 0);
          return { product, fullSku, inventory };
        });
    }

    // Function to get the group code from the data attribute
    // trim・空除去・重複除去を行う（同一コードの特価検索の無駄打ちを防ぐ）。
    // Set は挿入順を保持するため「最初にヒットした対象コードを採用」の順序は不変。
    function getGroupCodes() {
      const groupCodeElement = document.getElementById("group-code");
      if (!groupCodeElement) return [];
      return [
        ...new Set(
          (groupCodeElement.dataset.groupCode || "")
            .split(",")
            .map((code) => code.trim())
            .filter(Boolean)
        ),
      ];
    }

    // Function to get the medicines can be purchased from the data attribute
    function getMedicinesCanBePurchased() {
      const medicinesCanBePurchasedElement =
        document.getElementById("group-code");
      return medicinesCanBePurchasedElement
        ? medicinesCanBePurchasedElement.dataset.medicinesCanBePurchased ===
            "true"
        : false;
    }

    // Function to handle displaying errors
    function showError(inputEl, errorEl, message) {
      inputEl.style.background = "#E9B3B3";
      errorEl.innerHTML = message;
      errorEl.style.color = "#C00F0C";
    }

    // Function to process and display the variant data
    function processVariant(product, row, sku, inventory) {
      const medicinesCanBePurchased = getMedicinesCanBePurchased();
      let product_pharmaceuticals = "";
      let prohibited = false;
      if (product.tags.includes("医薬品")) {
        if (!medicinesCanBePurchased) {
          prohibited = true;
          product_pharmaceuticals =
            " <span style='color: #C00F0C; display: block;'>この商品はご購入いただけません</span>";
        }
      }

      const currentVariant = product.variants.find(
        (variant) => variant.sku === sku
      );
      if (!currentVariant) {
        console.log("Variant not found:", sku);
        return;
      }

      // Update thumbnail
      const thumbnailColumn = row.querySelector(".wl-thumbnail-column img");
      if (thumbnailColumn) {
        thumbnailColumn.src = product.featured_image;
      }

      // Update title
      const titleColumn = row.querySelector(".wl-title-column");
      if (titleColumn) {
        titleColumn.innerHTML = currentVariant.name + product_pharmaceuticals;
        titleColumn.style.color = "inherit";
      }

      // Update price
      // const priceColumn = row.querySelector('.wl-price-column');
      // if (priceColumn) {
      //   priceColumn.innerHTML = `<price-money><bdi>${formatMoney(
      //     currentVariant.price,
      //     window.shopSettings.moneyFormat
      //   )}</bdi></price-money>`;
      // }

      const inventoryColumn = row.querySelector(".wl-inventory-column");
      if (inventoryColumn) {
        inventoryColumn.innerHTML = inventory > 0 ? "在庫あり" : "入荷待ち";
      }

      const quantityColumn = row.querySelector(".wl-quantity-column");
      if (quantityColumn && !prohibited) {
        quantityColumn
          .querySelector("sku-quantity")
          .removeAttribute("aria-disabled");
        quantityColumn.firstElementChild.classList.remove("hidden");

        const quantityInput = quantityColumn.querySelector("input");
        if (quantityInput) {
          quantityInput.removeAttribute("hidden");
          // if (!inventory) {
          //   quantityInput.value = 0;
          //   quantityInput.max = 0;
          // } else {

          // }
          quantityInput.disabled = false;
          quantityInput.value = 0;
          // quantityInput.max = inventory;

          quantityInput.addEventListener("change", function (e) {
            let value = +e.target.value;
            // if (value > inventory) {
            //   value = inventory;
            // }

            formData = {
              ...formData,
              [row.dataset.rowIndex]: {
                id: currentVariant.id,
                sku: currentVariant.sku,
                quantity: value,
              },
            };
          });
        }
      }
      // Additional updates  here (inventory, quantity, etc.)
    }
    // inputs.forEach((input) => {
    //   input.addEventListener('blur', function (e) {
    //     let sku = e.target.value;
    //     if (!sku) {
    //       return;
    //     }

    //     //validation goes here
    //     /**
    //      * 1. RETURN ERROR: max length is 8, min length is 7
    //      * 2. RETURN ERROR: either 8 digis or 7 digits and 1 letter
    //      * 3. RETURN ERROR: only numbers, letters and hyphen are allowed
    //      * 4. RETURN ERROR: available alphabets are A-Z, a-z
    //      * 5. RETURN ERROR: if the string contain an alphabet, that alphabet can only be at the start
    //      * 6. AUTOMATIC REPLACE: full-width numbers are auto converted to half-width
    //      * 7. AUTOMATIC REPLACE: full-width letters are auto converted to half-width
    //      * 8. AUTOMATIC REPLACE: uppercase letters are auto converted to lowercase
    //      * 9. AUTOMATIC REPLACE: hyfen can be entered, but will be removed
    //      * 10. AUTOMATIC REPLACE: space is not allowed
    //      * 11. RETURN ERROR: if the string contains a hyfen, max length will be 9
    //      */
    //     let error = '';

    //     sku = sku.replaceAll(' ', '');
    //     sku = sku.replaceAll('-', '');

    //     sku = sku.replace(
    //       /[\uff01-\uff5e]/g,
    //       function (ch) { return String.fromCharCode(ch.charCodeAt(0) - 0xfee0); }
    //     );

    //     sku = sku.toLowerCase();

    //     e.target.value = sku;

    //     if (sku.length < 7) {
    //       // error = 'SKU must be at least 7 characters long';
    //       error = '品番が正しくないです';
    //     } else if (sku.length > 8) {
    //       // error = 'SKU must be at most 8 characters long';
    //       error = '品番が正しくないです';
    //     } else if (!/^[a-zA-Z0-9-]+$/.test(sku)) {
    //       // error = 'SKU can only contain letters, numbers and hyphen';
    //       error = '品番が正しくないです';
    //     } else if (/[a-zA-Z]/.test(sku)) {
    //       if (!/^[a-zA-Z][0-9]+$/.test(sku)) {
    //         // error = 'Alphabet can only be at the start';
    //         error = '品番が正しくないです';
    //       }
    //     }

    //     const row = e.target.closest('div[class^="row-"]');
    //     if (!row) {
    //       return;
    //     }
    //     const errorEl = row.querySelector('.sku__error-message');
    //     const inputEl = row.querySelector('.sku__input');

    //     if (error) {
    //       inputEl.style.background = "#E9B3B3";
    //       if (errorEl) {
    //         errorEl.innerHTML = error;
    //         errorEl.style.color = '#C00F0C';
    //       }

    //       return;
    //     } else {
    //       const inputEl = row.querySelector('.sku__input');
    //       inputEl.style.background = "#d9d9d9";
    //       if (errorEl) {
    //         errorEl.innerHTML = isMobile ? ":" : '';
    //         errorEl.style.color = 'inherit';
    //       }
    //     }

    //     const rowIndex = row.dataset.rowIndex;

    //     fetch(`/search?type=product&q=variants.sku:${sku}`)
    //       .then((response) => {
    //         return response.text();
    //       })
    //       .then((text) => {
    //         const parser = new DOMParser();
    //         const html = parser.parseFromString(text, 'text/html');
    //         const data = JSON.parse(
    //           html.querySelector('#search-results-data')?.textContent || '[]'
    //         );
    //         const inventory = JSON.parse(
    //           html.querySelector('#inventory-data')?.textContent || '{}'
    //         );

    //         if (!data || !data.length) {
    //           // alert('Product not found');
    //           error = '品番が正しくないです';
    //           inputEl.style.backgroundColor = "#E9B3B3";

    //           errorEl.innerHTML = error;
    //           errorEl.style.color = '#C00F0C';
    //           // clear(row);
    //           return;
    //         }

    //         const product = data[0];
    //         const currentVariant = product.variants.find(
    //           (variant) => variant.sku === sku
    //         );

    //         if (!currentVariant) {
    //           return;
    //         }

    //         // thumbnail
    //         const thumbnailColumn = row.querySelector('.wl-thumbnail-column');
    //         if (thumbnailColumn) {
    //           const img = thumbnailColumn.querySelector('img');

    //           if (img) {
    //             img.src = product.featured_image;
    //           }

    //           // vairant id
    //           const id = thumbnailColumn.querySelector('.wl-variant-id');
    //           if (id) {
    //             id.value = currentVariant.id;
    //           }
    //         }

    //         // title
    //         const titleColumn = row.querySelector('.wl-title-column');
    //         if (titleColumn) {
    //           titleColumn.innerHTML = currentVariant.name;
    //         }

    //         // price
    //         const priceColumn = row.querySelector('.wl-price-column');
    //         if (priceColumn) {
    //           priceColumn.innerHTML = `<price-money><bdi>${formatMoney(
    //             currentVariant.price,
    //             window.shopSettings.moneyFormat
    //           )}</bdi></price-money>`;
    //         }

    //         // inventory
    //         const inventoryColumn = row.querySelector('.wl-inventory-column');
    //         if (inventoryColumn) {
    //           inventoryColumn.innerHTML = inventory[currentVariant.sku] > 0 ? '在庫あり' : '入荷待ち';
    //         }

    //         // quantity
    //         const quantityColumn = row.querySelector('.wl-quantity-column');
    //         if (quantityColumn && parseInt(inventory[currentVariant.sku]) > 0) {
    //           quantityColumn
    //             .querySelector('sku-quantity')
    //             .removeAttribute('aria-disabled');

    //           quantityColumn.firstElementChild.classList.remove('hidden');
    //           const quantityInput = quantityColumn.querySelector('input');

    //           if (quantityInput) {
    //             quantityInput.removeAttribute('hidden');

    //             if (!inventory[currentVariant.sku]) {
    //               // quantityInput.disabled = true;
    //               quantityInput.value = 0;
    //               quantityInput.max = 0;
    //             } else {
    //               quantityInput.disabled = false;
    //               quantityInput.value = 0;
    //               quantityInput.max = inventory[currentVariant.sku];

    //               quantityInput.addEventListener('change', function (e) {
    //                 let value = +e.target.value;
    //                 if (value > inventory[currentVariant.sku]) {
    //                   value = inventory[currentVariant.sku];
    //                 }

    //                 formData = {
    //                   ...formData,
    //                   [rowIndex]: {
    //                     id: currentVariant.id,
    //                     sku: currentVariant.sku,
    //                     quantity: value,
    //                   },
    //                 };
    //               });
    //             }
    //           }
    //         }

    //         // const deleteButton = row.querySelector('.wl-delete-column');

    //         // if (deleteButton) {
    //         //   // deleteButton.firstElementChild.classList.remove('hidden');
    //         //   deleteButton.addEventListener('click', function (e) {
    //         //     e.preventDefault();
    //         //     clear(row);
    //         //   });
    //         // }
    //       })
    //       .catch((error) => {
    //         console.log('🚀 ~ error:', error);
    //       });
    //   });
    // });

    inputs.forEach((input) => {
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          e.target.blur();
        }
      });
    });

    const deleteButtons = table.querySelectorAll(".wl-delete-column");
    deleteButtons.forEach((deleteButton) => {
      deleteButton.addEventListener("click", function (e) {
        e.preventDefault();
        const row = e.target.closest('div[class^="row-"]');
        if (!row) {
          return;
        }
        clear(row);
      });
    });

    const buttons = this.querySelectorAll(".btnAddToCart");

    if (!buttons || buttons.length === 0) {
      return;
    }

    buttons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        // Check for zero quantities
        const hasZeroQuantity = Array.from(
          table.querySelectorAll("sku-quantity")
        ).some((input) => input.querySelector("input").value === "0");

        if (!Object.keys(formData) || !Object.keys(formData).length) {
          alert("1点以上の品番に数量1以上を指定して下さい。");
          return;
        } else {
          if (hasZeroQuantity) {
            alert("1点以上の品番に数量1以上を指定して下さい。");
            return;
          }
        }

        const body = {
          items: Object.values(formData)
            .reverse()
            .reduce((rs, item) => {
              const _item = rs.find((i) => i.id === item.id);

              if (_item) {
                _item.quantity += item.quantity;
              } else {
                rs.push({
                  id: item.id,
                  quantity: item.quantity,
                });
              }

              return rs;
            }, [])
            .reverse(),
        };
        body["sections"] = [
          "cart-notification-product",
          "cart-notification-button",
          "cart-icon-bubble",
        ];
        body["sections_url"] = "/";

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        console.log("🚀 ~ body:", body);
        config.body = JSON.stringify(body);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response) {
              console.log("🚀 ~ response:", response);
              // window.location.reload();
              window.location.href = "/cart";
            }
          })
          .catch((error) => {
            console.log("🚀 ~ error:", error);
          });
      });
    });

    function clear(row, keepInput = false) {
      delete formData[row.dataset.rowIndex];

      const input = row.querySelector(".wl-sku-column input");
      if (input) {
        if (!keepInput) input.value = "";
        input.style.background = "#d9d9d9";
      }

      // thumbnail
      const thumbnailColumn = row.querySelector(".wl-thumbnail-column");
      if (thumbnailColumn) {
        const img = thumbnailColumn.querySelector("img");

        if (img) {
          img.src = "";
        }

        // vairant id
        const id = thumbnailColumn.querySelector(".wl-variant-id");
        if (id) {
          id.value = "";
        }
      }

      // title
      const titleColumn = row.querySelector(".wl-title-column");
      if (titleColumn) {
        titleColumn.innerHTML = isMobile ? ":" : "";
      }

      // price
      // const priceColumn = row.querySelector('.wl-price-column');
      // if (priceColumn) {
      //   priceColumn.innerHTML = isMobile ? ':' : '';
      // }

      // inventory
      const inventoryColumn = row.querySelector(".wl-inventory-column");
      if (inventoryColumn) {
        inventoryColumn.innerHTML = isMobile ? ":" : "";
      }

      // quantity
      const quantityColumn = row.querySelector(".wl-quantity-column");
      if (quantityColumn) {
        quantityColumn
          .querySelector("sku-quantity")
          .setAttribute("aria-disabled", true);
        // quantityColumn.firstElementChild.classList.add('hidden');

        const quantityInput = quantityColumn.querySelector("input");

        if (quantityInput) {
          // quantityInput.setAttribute("hidden", true);
          quantityInput.value = "";
        }
      }

      // const deleteButton = row.querySelector('.wl-delete-column');
      // if (deleteButton) {
      //   deleteButton.firstElementChild.classList.add('hidden');
      // }
    }
  });
})();

if (!customElements.get("sku-quantity")) {
  customElements.define(
    "sku-quantity",
    class SkuQuantity extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });
        this.input.addEventListener("change", this.onInputChange.bind(this));
        this.querySelectorAll("button").forEach((button) =>
          button.addEventListener("click", this.onButtonClick.bind(this))
        );
      }

      connectedCallback() {
        this.validateQtyRules();
      }

      disconnectedCallback() {}

      onInputChange(event) {
        this.validateQtyRules();
      }
      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        if (event.target.name === "plus") {
          if (
            parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
            this.input.value == 0
          ) {
            this.input.value = this.input.dataset.min;
          } else {
            this.input.stepUp();
          }
        } else {
          this.input.stepDown();
        }

        if (previousValue !== this.input.value)
          this.input.dispatchEvent(this.changeEvent);

        if (
          this.input.dataset.min === previousValue &&
          event.target.name === "minus"
        ) {
          this.input.value = parseInt(this.input.min);
        }
      }
      validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
          const buttonMinus = this.querySelector(
            ".sku-quantity__btn[name='minus']"
          );
          buttonMinus.classList.toggle(
            "disabled",
            parseInt(value) <= parseInt(this.input.min)
          );
          if (value < this.input.min) this.input.value = this.input.min;
        }
        if (this.input.max) {
          const max = parseInt(this.input.max);
          const buttonPlus = this.querySelector(
            ".sku-quantity__btn[name='plus']"
          );
          buttonPlus.classList.toggle("disabled", value >= max);
          if (value > max) this.input.value = max;
        }
      }
    }
  );
}
